import React, { Component } from 'react';
import {Link} from "react-router-dom"

import "./Header-Menu.scss"

import MenuItem from "../Header-MenuItem/Header-MenuItem"

class AppMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    getItems() {
        return this.props.menuItems.menu.map((item, index) =>
            <MenuItem closeMenu={this.props.closeMenu} scrollFromMenu={this.props.scrollFromMenu} key={index.toString()} item={item} />
        );
    }

    goHomepage() {
        window.dataLayer.push({
            'event': 'virtualPageview',
            'virtualPageURL': "/",
            'virtualPageTitle': "ynet - איך קונים ברשת?"
        });
        this.props.closeMenu();
    }
    render() {
        const isActive = (this.props.menuActive === 0 ? "" : " active")
        return (
            <div className={"appmenu " + isActive}>
                <div className="padding">
                    <ul>
                        <li>
                            <div className="box">
                                <Link to="/" onClick={this.goHomepage}>
                                    דף הבית
                            </Link>
                            </div>
                        </li>
                        {this.getItems()}
                    </ul>
                </div>
            </div>
        )
    }
}

export default AppMenu;



// WEBPACK FOOTER //
// ./src/components/Header/components/Header-Menu/Header-Menu.js